import { publicUrlFor } from "../../../../globals/constants";

export default function SectionTermsConditionsUse({ _data }) {
  return (
    <div
      className="section-full p-t120 p-b90 site-bg-white tw-why-choose-area2 mt-3"
      style={{
        backgroundImage: `url(${publicUrlFor(
          "/assets/images/background/bg-6.jpg"
        )})`,
      }}
    >
      <div className="services-gallery-block-outer2">
        <div className="container">
          {/* <!-- TITLE START--> */}
          <div
            className="section-head center wt-small-separator-outer"
            style={{ maxWidth: "none" }}
          >
            <div className="wt-small-separator site-text-primary">
              <div>{_data.title}</div>
            </div>
            <p
              className="section-head-text text-justify"
              style={{ maxWidth: "none" }}
            >
              {_data.description}
            </p>
          </div>
          {/* <!-- TITLE END--> */}
        </div>
      </div>
      {_data.terms.map((item) => (
        <div
          className="services-gallery-block-outer2"
          key={"terms-conditions-use-" + item.index}
        >
          <div className="container">
            <div className="section-head" style={{ maxWidth: "none" }}>
              <h4 className="wt-title">
                {item.index}. {item.title}
              </h4>
              <div className="wt-box-content">
                <p className="text-justify">{item.content}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
      
      <div className="services-gallery-block-outer2 mt-4">
        <div className="container">
          <div className="section-head" style={{ maxWidth: "none" }}></div>
          <p className="text-justify"><em>{_data.misuseNotice}</em></p>
          <p className="text-justify"><em>{_data.lastUpdate}</em></p>
        </div>
      </div>

    </div>
  );
}